import { camelizeKeys } from 'humps';
import api from './api';
import * as docPartnerApi from 'features/document/edit/partners/api';
import * as actionTypes from './actionTypes';
import { sendHttpRequest, sendHttpCommandAndWaitForEvent } from 'actions/actionCreators/httpActions';
import * as eventTypes from './eventTypes';
import { showError } from 'actions/actionCreators/snackbarActions';

export function loadPositions() {
  return async (dispatch, getState) => {
    const positions = getState().entities.positions;
    if (positions) {
      return;
    }

    try {
      const response = await dispatch(sendHttpRequest(api.getPositions()));
      dispatch({ type: actionTypes.LOAD_POSITIONS_SUCCEEDED, payload: response });
    } catch (error) {
      dispatch({ type: actionTypes.LOAD_POSITIONS_FAILED, error });
      dispatch(showError(error.message, error.correlationId));
    }
  };
}

export function loadPartnerDetails(uniqueID) {
  return async dispatch => {
    dispatch({ type: actionTypes.LOAD_PARTNER_DETAILS_STARTED, key: uniqueID });

    try {
      const response = await dispatch(sendHttpRequest(api.getPartnerDetails(uniqueID)));
      dispatch({
        type: actionTypes.LOAD_PARTNER_DETAILS_SUCCEEDED,
        key: uniqueID,
        ...response
      });
      return response;
    } catch (error) {
      dispatch({ type: actionTypes.LOAD_PARTNER_DETAILS_FAILED, key: uniqueID, error });
      dispatch(showError(error.message, error.correlationId));
    }
  };
}

export function loadPersons(search) {
  //no redux cache
  return () => api.getPersons(search);
}

export function loadSegregatedPersons(search) {
  //no redux cache
  return () => api.getSegregatedPersons(search);
}

export function saveContactPersons(documentId, siteId, partnerId, contactPersons, callback = () => {}) {
  return async dispatch => {
    dispatch({
      type: actionTypes.UPDATE_CONTACT_PERSONS_STARTED,
      payload: contactPersons,
      partnerId: partnerId
    });
    const event = await dispatch(
      sendHttpCommandAndWaitForEvent(
        docPartnerApi.saveContactPersons(documentId, siteId, partnerId, contactPersons),
        'saveContactPersons',
        [eventTypes.CONTACT_PERSONS_UPDATED]
      )
    );
    if (event.ok) {
      dispatch({
        type: actionTypes.UPDATE_CONTACT_PERSONS_SUCCEEDED,
        contactPersons: event.eventBody.documentPartnerContactPersons,
        partnerId: partnerId
      });
      callback();
    } else {
      dispatch({
        type: actionTypes.UPDATE_CONTACT_PERSONS_FAILED,
        payload: { contactPersons, error: event },
        partnerId: partnerId
      });
    }
  };
}

export function loadContactPersons(documentId, siteId, partnerId) {
  return async (dispatch, getState) => {
    const contactPersons = getState().currentOffer.clientContactPersonsData[partnerId];
    let shouldCallApi = !contactPersons || (!contactPersons.loaded && !contactPersons.loading);

    if (!shouldCallApi) {
      return;
    }

    dispatch({ type: actionTypes.LOAD_CONTACT_PERSONS_STARTED, key: partnerId });

    try {
      const response = await dispatch(sendHttpRequest(docPartnerApi.getContactPersons(documentId, siteId, partnerId)));
      const result = camelizeKeys(response);
      dispatch({
        type: actionTypes.LOAD_CONTACT_PERSONS_SUCCEEDED,
        key: partnerId,
        contactPersons: result
      });
    } catch (error) {
      dispatch({ type: actionTypes.LOAD_CONTACT_PERSONS_FAILED, key: partnerId, error });
      dispatch(showError(error.message, error.correlationId));
    }
  };
}

export function loadContactPersonsSummary(documentId, siteId, partnerId) {
  return async dispatch => {
    try {
      const response = await dispatch(
        sendHttpRequest(docPartnerApi.getDocumentPartnerContactPersonsSummary(documentId, siteId, partnerId))
      );
      const result = camelizeKeys(response);
      dispatch({
        type: actionTypes.LOAD_CONTACT_PERSONS_SUMMARY_SUCCEEDED,
        contactPersonsSummary: result,
        key: partnerId
      });
    } catch (error) {
      dispatch(showError(error.message, error.correlationId));
    }
  };
}
